import React, { useCallback } from "react"

import { SettingRow, Switch } from "@coval/ui"

import type { WebSocketFieldProps } from "./types"

export const SpeechActivityFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const isEnabled = Boolean(metadata.speech_activity_enabled)

  const handleToggle = useCallback(
    (checked: boolean) => {
      onMetadataUpdate({ speech_activity_enabled: checked })
    },
    [onMetadataUpdate],
  )

  return (
    <SettingRow
      label="Speech Activity Markers"
      tooltip='When enabled, {"type": "utterance_started", "utterance_id": "..."} and {"type": "utterance_end", ...} messages are sent as the simulated caller starts and stops speaking.'
    >
      {(controlId) => (
        <Switch
          id={controlId}
          checked={isEnabled}
          onCheckedChange={handleToggle}
          disabled={disabled}
        />
      )}
    </SettingRow>
  )
}
